import React, { useEffect, useState, memo } from 'react'
import { fetchAttendance } from '../../../../API/API';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

import classes from './CheckInfo.module.scss';
import locationImg from './../../../../assets/icons/Location_on.svg';
import clock from './../../../../assets/icons/Clock.svg';

const CheckInInfo = () => {
    const [AttendanceData, setAttendanceData] = useState([]);
    const state = useSelector(state=>state.login)
    useEffect(() => {
        const viewAtt = async () => {
            const userID = localStorage.getItem('userID');
            const data = JSON.parse(localStorage.getItem('data'));

            if (userID !== null) {
                const date = new Date();
                const currentDate = date.toISOString().substring(0, 10);

                try {
                    
                    const response = await fetchAttendance(userID, data.empid, data.token, currentDate, currentDate);
                    setAttendanceData(response.data);

                } catch (error) {
                    toast(error.message, {
                        icon: '❗',
                        duration: 4500
                    });
                }
            }
        };

        viewAtt();
    }, [state.closeCheckOut,state.closeCheckIn]);


    return (
        <div className={classes.CheckInInfo}>
            <div className={classes.CheckedInLocation}>
                <h3>Checked In Location</h3>
                <p> <img src={locationImg} alt='locationImg' width={15} /> {AttendanceData && AttendanceData.length > 0 && AttendanceData[0].in_from !== null ? AttendanceData[0].in_from.replace(/_/g, " ") : 'Not Checked In Yet'}    </p>
            </div>
            <div className={classes.CheckedInTime}>
                <h3>Checked In Time</h3>
                <p><img src={clock} alt='locationImg' width={15} /> {AttendanceData && AttendanceData.length > 0 && AttendanceData[0].in_time !== null ? AttendanceData[0].in_time : 'Not Checked In Yet'}  </p>
            </div>
        </div>
    );
};

export default memo(CheckInInfo);


